

import React from 'react';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import RegularCard from '../../mui-components/Card/RegularCard';
import ClientSpreadsheetsTable from '../../containers/domain/client-spreadsheet/ClientSpreadsheetsTable';

const ClientSpreadsheetsListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de planilhas de clientes"
        content={<ClientSpreadsheetsTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default ClientSpreadsheetsListingView;
